import ApiService from "../../../common/api.service";
import { router } from "../../../router";
import { Message } from "element-ui";

export async function GetOwners({ commit }, option) {
  try {
    ApiService.init("heroku");
    commit("OWNER_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.query("/v1/customer", option);
    commit("OWNER_SUCCESS", _response);
  } catch (error) {
    commit("OWNER_ERROR", { result: error.message });
  }
}

export async function UpdateStatusCustomer({ commit }, form) {
  try {
    ApiService.init("heroku");
    commit("EDIT_CUSTOMER_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.put("/v1/customer/" + form.id + '/' + form.isActive);
    commit("EDIT_CUSTOMER_SUCCESS", _response);
    Message({
      message: "Update completed",
      type: "success"
    });
  } catch (error) {
    commit("EDIT_CUSTOMER_ERROR", { result: error.message });
  }
}
export async function CreateOwner({ commit }, form) {
  try {
    form.external_user.map(item => {
      item.customer_number = form.customer_number;
      return item;
    });
    form.customer_address.map(item => {
      item.customer_id = form.customer_number;
      return item;
    });
    form.customer_name = form.external_user[0].fullname;
    ApiService.init();
    commit("CREATE_OWNER_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.post("/ownermanagement", form);
    commit("CREATE_OWNER_SUCCESS", { results: _response });
    Message({
      message: "Create completed",
      type: "success"
    });
    router.go(-1);
  } catch (error) {
    commit("CREATE_OWNER_ERROR", { result: error.message });
  }
}

export async function GetOwner({ commit }, id) {
  try {
    ApiService.init("heroku");
    commit("GET_OWNER_REQUEST");
    ApiService.setHeader();
    const customer = await ApiService.get(`/v1/customer/${id}`);
    const customer_address = await ApiService.get(
      `/v1/customer-address/customer-id/${id}`
    );
    const employee = await ApiService.get(`/v1/employee/customer-id/${id}`);

    commit("GET_OWNER_SUCCESS", {
      data: {
        customer: customer,
        customer_address: customer_address,
        employee: employee
      }
    });
  } catch (error) {
    commit("GET_OWNER_ERROR", { result: error.message });
  }
}

export async function UpdateOwner({ commit }, form) {
  try {
    const { oracleCustomerId, parentId } = form.params;
    ApiService.init("heroku");
    commit("EDIT_OWNER_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.post(
      `/v1/employee/customer-id/${oracleCustomerId}/parent-id/${parentId}`,
      form
    );
    commit("EDIT_OWNER_SUCCESS", { results: _response });
    Message({
      message: "Update completed",
      type: "success"
    });
    router.go(-1);
  } catch (error) {
    commit("EDIT_OWNER_ERROR", { result: error.message });
  }
}

export async function DeleteOwner({ commit }, id) {
  try {
    ApiService.init();
    commit("DELETE_OWNER_REQUEST");
    ApiService.setHeader();
    await ApiService.delete("/ownermanagement/" + id);
    commit("DELETE_OWNER_SUCCESS", { id: id });
    Message({
      message: "Delete completed",
      type: "success"
    });
  } catch (error) {
    commit("DELETE_OWNER_ERROR", { result: error.message });
  }
}

export async function CreateSubStore({ commit }, form) {
  try {
    ApiService.init();
    commit("CREATE_SUBSTORE_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.post("/substore", form);
    commit("CREATE_SUBSTORE_SUCCESS", { results: _response });
    router.push("/owner");
  } catch (error) {
    commit("CREATE_SUBSTORE_ERROR", { result: error.message });
  }
}
export async function CreateEmployee({ commit }, form) {
  try {
    ApiService.init();
    commit("CREATE_EMPLOYEE_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.post("/employe", form);
    commit("CREATE_EMPLOYEE_SUCCESS", { results: _response });
    router.push("/owner");
  } catch (error) {
    commit("CREATE_EMPLOYEE_ERROR", { result: error.message });
  }
}

